import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { MoveinExportHistory, MoveinExtendedData } from '../../../models/movein-export-hist.model';
import { MoveinHistoryService } from './movein-history.service';
import { DirectionService } from '../../../services/direction.service';
import { Table } from 'primeng/table';
import { TableModule } from 'primeng/table';
import { ProgressBarModule } from 'primeng/progressbar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateService } from '../../../services/translate.service';
import { Pagination } from '../../../services/pagination.abstruct';

@Component({
	selector: 'app-movein-history',
	standalone: true,
	imports: [CommonModule, TableModule, ProgressBarModule, ButtonModule, InputTextModule, TooltipModule],
	templateUrl: './movein-history.component.html',
	styleUrls: ['./movein-history.component.scss']
})
export class MoveinHistoryComponent extends Pagination implements OnInit, OnDestroy {
	records: MoveinExportHistory[] = [];
	loading = false;
	errorMessage = '';
	expandedRows: Record<number, boolean> = {};
	additionalDataByDose: Record<number, MoveinExtendedData[]> = {};
	additionalLoadingByDose: Record<number, boolean> = {};
	additionalErrorByDose: Record<number, string> = {};
	private subs = new Subscription();

	@ViewChild('dt') dt?: Table;

	globalFilterFields: string[] = ['MoveIn_ExportRecID', 'DoseRecID', 'Dose', 'MoveInCreateDate', 'UserName', 'RoleName', 'filePath'];

	constructor(private service: MoveinHistoryService, public directionServ: DirectionService, public translateServ: TranslateService) 
	{
		super();
	}

	ngOnInit(): void {
		this.loadRecords();
	}

	loadRecords(): void {
		this.loading = true;
		this.errorMessage = '';
		const sub = this.service.getMoveinExportHistory().subscribe({
			next: (data) => {
				this.records = data || [];
				this.loading = false;
			},
			error: (err) => {
				this.loading = false;
				this.errorMessage = 'Failed to load movein export history.';
				console.error(err);
			}
		});
		this.subs.add(sub);
	}

	applyFilter(event: Event): void {
		const value = (event.target as HTMLInputElement).value;
		this.dt?.filterGlobal(value, 'contains');
	}

	download(row: MoveinExportHistory): void {
		if (row && row.Url) {
			window.open(row.Url, '_blank');
		}
	}

	toggleRow(row: MoveinExportHistory): void {
		const rowKey = row.MoveIn_ExportRecID;
		const doseRecId = row.DoseRecID;
		this.expandedRows[rowKey] = !this.expandedRows[rowKey];

		if (this.expandedRows[rowKey] && !this.additionalDataByDose[doseRecId] && !this.additionalLoadingByDose[doseRecId]) {
			this.loadAdditionalData(doseRecId);
		}
	}

	isRowExpanded(row: MoveinExportHistory): boolean {
		return !!this.expandedRows[row.MoveIn_ExportRecID];
	}

	copyLine(line: string): void {
		void navigator.clipboard?.writeText(line || '');
	}

	private loadAdditionalData(doseRecId: number): void {
		this.additionalLoadingByDose[doseRecId] = true;
		delete this.additionalErrorByDose[doseRecId];

		const sub = this.service.getMoveinAdditionalData(doseRecId).subscribe({
			next: (data) => {
				this.additionalDataByDose[doseRecId] = data || [];
				this.additionalLoadingByDose[doseRecId] = false;
			},
			error: (err) => {
				this.additionalLoadingByDose[doseRecId] = false;
				this.additionalErrorByDose[doseRecId] = 'Failed to load movein additional data.';
				console.error(err);
			}
		});
		this.subs.add(sub);
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
